import { _deserializable } from '../_deserializable';

export class ItemsRequest extends _deserializable {

  public customer: string;
  public pricelist: string;

}
